import React from "react";
import { formatUSD, formatPercentage, formatAmount } from "../../utils/format";
import { useTokenIcon, useLendingPoolUrl } from "../../hooks/useUrlGenerator";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import PairLeftTitle from "../PairLeftTitle";
import { useOffchainAccountLendingPool } from "../../hooks/useOffchain";
import useGenericCall from "../../hooks/useGenericCall";
import { PoolTokenType } from "impermax-sdk";


export default function SupplyPosition() {
  const bData = useGenericCall(useOffchainAccountLendingPool(), async lendingPool => (
    Promise.all([lendingPool.getBorrowableA(), lendingPool.getBorrowableB()].map(async offchainAccountBorrowable => ({
      symbol: await offchainAccountBorrowable.getPoolToken().getSymbol(),
      suppliedAmount: await offchainAccountBorrowable.getAmount(),
      suppliedValue: await offchainAccountBorrowable.getValue(),
      supplyAPR: await offchainAccountBorrowable.getPoolToken().getSupplyAPR(),
    })))
  ));

  const lendingPoolUrl = useLendingPoolUrl();
  const tokenIcons = [useTokenIcon(PoolTokenType.BorrowableA), useTokenIcon(PoolTokenType.BorrowableB)]

  if (!bData) {
    return (null);
  }

  // Hide if equity is less than $1
  if (bData[0].suppliedValue + bData[1].suppliedValue < 1) return (null);

  return (<Link to={lendingPoolUrl} className="position row">
    <Col className="currency-name d-none d-md-block">
      <PairLeftTitle/>
    </Col>
    <Col className="supply-balance-details">
      <Row>
        <Col className="details-amount">
          {bData.map((data, i) => (<div key={i}>
            <img className="currency-icon" src={tokenIcons[i]} /> {formatAmount(data.suppliedAmount)} {data.symbol}
          </div>))}
        </Col>
        <Col className="details-value">
          {bData.map((data, i) => (<div key={i}>{formatUSD(data.suppliedValue)}</div>))}
        </Col>
        <Col className="details-apr">
          {bData.map((data, i) => (<div key={i}>{formatPercentage(data.supplyAPR)}</div>))}
        </Col>
      </Row>
    </Col>
  </Link>);
}